import * as React from 'react';

import { IBankDesktopSchema } from '../../../../repositories/newbuilding-card/entities/newbuilding/BankDesktopSchema';
import { BankItem } from '../BankItem';

export interface IBankListItemProps {
  bank: IBankDesktopSchema;
  onLinkClick?(bank: IBankDesktopSchema): void;
}

export const BankListItem: React.FC<IBankListItemProps> = ({ bank, onLinkClick }) => {
  const handleLinkClick = React.useCallback(() => {
    if (onLinkClick) {
      onLinkClick(bank);
    }
  }, [onLinkClick, bank]);

  return (
    <BankItem logoUrl={bank.secondSquareImageUrl} name={bank.name} url={bank.searchUrl} onLinkClick={handleLinkClick} />
  );
};
